import { useState, useCallback, useContext } from "react"
import { Source } from "../types/route"
import { post_middleware_osrm_search } from "services/custom_services"
import useCancelToken from "hooks/useCancelToken"
import AuthContext from "store/context/PublicContext"

interface UseSourcesReturn {
  sources: Source[]
  loading: boolean
  error: string | null
  searchSources: (queryString: string) => Promise<void>
}

export const useSources = (): UseSourcesReturn => {
  const [loading, setLoading] = useState<boolean>(false)
  const [sources, setSources] = useState<Source[]>([])
  const [error, setError] = useState<string | null>(null)
  const { newCancelToken } = useCancelToken()
  const {
    user: { token },
  } = useContext(AuthContext)

  const searchSources = useCallback(async (queryString: string) => {
    try {
      setLoading(true)
      setError(null)

      // const data: SourcesResponse = await apiService.searchSources(queryString);

      let _body = {
        from: 0,
        size: 100,
        queryString,
        fields: ["id", "name", "aliases"],
      }

      const data: any = await post_middleware_osrm_search("sources", _body, token, newCancelToken())

      if (data?.data?.code === 200) {
        setSources(data?.data?.message?.records)
      } else {
        throw new Error("Failed to fetch sources")
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred")
      setSources([])
    } finally {
      setLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    sources,
    loading,
    error,
    searchSources,
  }
}
